module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_3.41ea3953.svg";